module.exports = __webpack_public_path__ + "img/xmark.8f4153e9.svg";